// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","appliance":"styles_appliance__b+kb+","applianceLabel":"styles_applianceLabel__NLgQH"};